var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('radio-group-input', {
    staticClass: "energy-efficiency-select",
    attrs: {
      "label": _vm.label,
      "value": _vm.value,
      "collection": _vm.energyEfficiencyClasses,
      "errors": _vm.errors,
      "include-blank": "Keine"
    },
    on: {
      "input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(optionProps) {
        return [_c('energy-efficiency-class', {
          attrs: {
            "value": optionProps.value
          }
        })]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566028b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/EnergyEfficiencySelect.vue
// module id = 1992
// module chunks = 0